import { atom } from "jotai";

export const isChewyBalanceOpenAtom = atom(false);

export const openChewyBalanceAtom = atom(
  (get) => get(isChewyBalanceOpenAtom),
  (get, set) => {
    set(isChewyBalanceOpenAtom, true);
  }
);

export const closeChewyBalanceAtom = atom(
  (get) => get(isChewyBalanceOpenAtom),
  (get, set) => {
    set(isChewyBalanceOpenAtom, false);
  }
);

export const toggleChewyBalanceAtom = atom(
  (get) => get(isChewyBalanceOpenAtom),
  (get, set) => {
    set(isChewyBalanceOpenAtom, !get(isChewyBalanceOpenAtom));
  }
);